import HospitalUserDetails from './HospitalUserDetails';

export default HospitalUserDetails;
